import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WifiCallingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wifi_calling"}/>
}
